import {PaymentCodeEnum, PayoutWebModel} from "../../payments";

export class PayoneerPayoutModel extends PayoutWebModel {
    systemName = PaymentCodeEnum.Payoneer

    required = [
        'amount', 'description', 'fromAccount',
        'destinationAccount',
        'verificationType'
    ]

    values = {
        fromAccount: '', amount: '',
        verificationType: '', autosplit: false, destinationAccount: ''
    }
}